module.exports = __webpack_public_path__ + "static/media/valor2.456e7b25.png";